import LogoQl from '@/Assets/Img/logo-querolog.png';
import MotoboyDisponivel from '@/Assets/Img/motoboy_disponivel.png';
import MotoboyEstabelecimento from '@/Assets/Img/motoboy_estabelecimento.png';
import MotoboyEntrega from '@/Assets/Img/motoboy_corrida.png';
import PlaceMarker from '@/Assets/Img/place_marker.png';
import PlacePedingOrderMarker from '@/Assets/Img/place_pending_order_marker.png';

export const image = {
  logo: LogoQl,
  marker_disponivel: MotoboyDisponivel,
  marker_indo_estabelecimento: MotoboyEstabelecimento,
  marker_entregando: MotoboyEntrega,
  marker_place: PlaceMarker,
  marker_place_pending_order: PlacePedingOrderMarker,
};
